/**
 * Shared formatting utilities for the storefront.
 * All prices are stored and computed as integer centimes (minor units).
 * See docs/plans/customer-storefront/04-i18n-strategy.md §6b.
 */
/** Format centimes to a human-readable MAD price string. */
export function formatPrice(amountInCentimes, locale) {
    return new Intl.NumberFormat(locale === 'en' ? 'en-MA' : 'fr-MA', {
        style: 'currency',
        currency: 'MAD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
    }).format(amountInCentimes / 100);
}
